import { render } from "./MainView.vue?vue&type=template&id=399afe30"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import exportComponent from "/home/felix/ContinuousLabs/clients/bloqs4/parribaclub/control/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__